import { queryKeys } from "../queryKeys";
import { type Billing, getBillingOverview } from "../rest/billing";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetBillingOverview = ({
  options,
}: {
  options?: QueryOptions<Billing>;
} = {}) => {
  const { data: billing, ...rest } = useRequest(
    queryKeys.billing.overview(),
    getBillingOverview,
    {
      refetchInterval: false,
      ...options,
    },
  );

  return { billing, ...rest };
};
